import { useEffect } from "react";

interface UseSwipeAnimationProps {
  needShowAnimation: () => Promise<boolean>;
  setLastAnimation: () => void;
  itemsLength: number;
  rowMapRef: React.MutableRefObject<any>;
}

export const useSwipeAnimation = ({
  needShowAnimation,
  setLastAnimation,
  itemsLength,
  rowMapRef,
}: UseSwipeAnimationProps) => {
  
  useEffect(() => {
    let isMounted = true;
    needShowAnimation().then((needShow) => {
      if (isMounted && needShow && itemsLength > 0) {
        const timer = setTimeout(() => {
          rowMapRef.current?.['idx-0']?.manuallySwipeRow(-60);
          setTimeout(() => {
            rowMapRef.current?.['idx-0']?.closeRow();

            setTimeout(() => {
              rowMapRef.current?.['idx-0']?.manuallySwipeRow(150);

              setTimeout(() => {
                rowMapRef.current?.['idx-0']?.closeRow();
              }, 500);
            }, 300);
          }, 300);
        }, 300);
        return () => clearTimeout(timer);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [itemsLength]);

  const handleRowOpen = async () => {
    await setLastAnimation();
  };

  return { handleRowOpen };
};